export default __webpack_public_path__ + "static/media/s0_male.5fdff559.wav";